import { useShoppingBasketInfoWithDefaultData } from '#src/clientState/providers';
import { ProductType } from '#src/generated/graphql';
import {
  concatAnalyticsProductTypes,
  groupProductsByType,
  isShoppingBasketProductsLoaded,
} from '#src/utils';
import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';
import React, { useMemo } from 'react';

const EmptyComponentWithChildren = ({ children }) => children;

const getProviderValue = (products: ProductType[]) => {
  return `/${concatAnalyticsProductTypes(products)}/payment`;
};

const getProvider = (products: ProductType[]) => {
  const value = getProviderValue(products);
  return createTrackingPageProvider({
    pageViewName: '',
    pageMapper: () => value,
    category: value,
  });
};

export const PageTrackingProvider = ({ children }) => {
  const { products, loading } = useShoppingBasketInfoWithDefaultData();

  const productTypesList = useMemo(
    () => groupProductsByType(products),
    [products]
  );
  const Provider = useMemo(
    () => getProvider(productTypesList),
    [productTypesList]
  );

  if (!isShoppingBasketProductsLoaded(products, loading))
    return <EmptyComponentWithChildren>{children}</EmptyComponentWithChildren>;

  return <Provider>{children}</Provider>;
};
